/**
 * Route for `campaign-templates`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignTemplatesPage } from "../features/campaign-templates/CampaignTemplatesPage";

export const campaignTemplatesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-templates",
	component: CampaignTemplatesPage,
});

export default campaignTemplatesRoute;
